export enum VOLUME_ALLOCATION {
  LastMonth = "Last Month Commitment",
  Minimum = "Minimum Commitment",
  LatestQuote = "Latest Quote",
}

export enum REBATE_INFORMATION {
  EffectiveQuote = "Effective Quote",
  YtdSpend = "YTD Spend",
  CurrentNext = "Current/Next Rebate",
  SpendNeededForNextTier = "Spend needed for Next Tier"
}


export const rebateInformation: any = [
  {
    "rebate_information": "EffectiveQuote",
    "ATKORE": 70.23,
    "NUCOR": 67.80,
    "ZEKELMAN": 76.98
  },
  {
    "rebate_information": "YtdSpend",
    "ATKORE": { value: 1200000, unit: "$" },
    "NUCOR": { value: 3500000, unit: "$" },
    "ZEKELMAN": { value: 500000, unit: "lbs" },
  },
  {
    "rebate_information": "CurrentNext",
    "ATKORE": { current: 3, next: 4 },
    "NUCOR": { current: 1, next: 2 },
    "ZEKELMAN": { current: 1, next: 3 },
  },
  {
    "rebate_information": "Speed",
    "ATKORE": { value: 1200000, unit: "$" },
    "NUCOR": { value: 1200000, unit: "$" },
    "ZEKELMAN": { value: 500000, unit: "lbs" },
  }
]

export enum USER_ROLE {
  Manager = "Manager",
  Lead = "Lead",
}

export enum APPROVAL_STATUS {
  NoChange = "No Change",
  Requested = "Approval Requested",
  Pending = "Pending Approval",
  Self = "Self Approved",
  Approved = "Approved",
}

export enum Error_MESSAGE {
  CostTooLow = "Value  is less than 30% decrease over calculated board cost! Consider entering a higher value",
  CostTooHigh = "Value is more than 30% increase over calculated board cost! Consider entering a lower value",
  CostLessThanVendorQuote = "Value entered is below quotation and may lead to negative PPV. Please enter a higher value !",
  AllocationTooLow = "Value entered cannot be 30% lower than Projected Release ! Please enter a higher value",
  AllocationTooHigh = "Value entered cannot be 30% more than Projected Release ! Please enter a lower value.",
  POCostValueMsg1 = "The weighted average PO cost is ",
  wirePOCostValueMsg1 = "The maximum quoted value is ",
  POCostValueMsg2 = "which exceeds the finalized recommendation and may result in a negative PPV. Please review and adjust the value accordingly.",
  wirePOCostValueMsg2 = "which exceeds the finalized recommendation. Any volume bought at this level will result in negative PPV",
}

export enum Module_Name {
  upcoming_negotiations = "Negotiations & Allocations",
  business_cost = "Board Cost Setting",
  compliance_monitoring = "Target Monitoring",
  nia_opportunity = "Rebate Opportunity",
}

export enum KPI_Name {
  ytd_spend = "YTD Spend (Stock)",
  ytd_volume = "YTD Sales Volume (Stock)",
  ytd_sales = "YTD Sales (Stock)",
  ytd_tm = "YTD Transaction Margin (Stock)",
  yoy_spend = "YoY Spend",
  yoy_volume = "YoY Sales Volume",
  yoy_sales = "YoY Sales",
  yoy_tm = "YoY Transaction Margin",
}

export enum CD_Routes {
  upcoming_negotiations = "/quote-assessment",
  business_cost = "/cost-setting",
  compliance_monitoring = "/cost-compliance",
  nia_opportunity = "/nia-opportunity",
}

export const commodityHeader: any = {
  "Steel Conduit": "3/4 EMT Quote",
  "PVC Conduit": "4 PVC 40 Quote",
};

export const defaultVendor: any = {
  "Steel Conduit": "ATKORE",
  "PVC Conduit": "ATKORE",
};

export const disableScreenConfig: { [key: string]: string } = {
  "Board Cost Setting": "boardCost",
  "Vendor Quote Assesment": "vendorQuoteAssesment",
  "Quote Upload": "quoteUpload",
  "Volume Allocation": "volumeAllocation",
  "Allocation Summary": "allocationSummary",
  "Board Cost Trend": "boardCost",
};

export const locationCodes: any = {
  All: "All",
  Atlanta: "ATL",
  Boston: "BOS",
  California: "CAL",
  Chicago: "CHI TOTAL",
  "Chicago - Illinois/Wisconsin": "CHI IL WI",
  "Chicago - Indiana": "CHI IN",
  "Chicago - Michigan": "CHI MI",
  Dallas: "DAL",
  Minneapolis: "MIN TOTAL",
  "Minneapolis - Central": "MIN",
  "Minneapolis - Iowa": "MIN IO",
  "New York": "NY",
  Pittsburgh: "PIT TOTAL",
  "Pittsburgh - Central": "PIT",
  "Pittsburgh - North East": "PIT NE",
  "Pittsburgh - West": "PIT WE",
  "Pittsburgh - Kentucky": "PIT KY",
  Seattle: "SEA TOTAL",
  "Seattle - Central": "SEA",
  "Seattle - Alaska": "SEA AL",
  Southwest: "SW",
  Richmond: "RIC",
  "St. Louis": "STL",
  Tampa: "TAM",
};



export const DOTCHARTCOLORS = [
  '#1f77b4',
  '#ff7f0e',
  '#2ca02c',
  '#d62728',
  '#9467bd',
  '#8c564b',
  '#e377c2',
  '#7f7f7f',
  '#bcbd22',
  '#17becf',
];

export const backendDataDot = {
  chartData: [
    { district: 'Atlanta', atkore: 31.69, zekelman: 64.75, nucor: 16.65 },
    { district: 'Boston', atkore: 68.40, zekelman: 14.75, nucor: 35.55 },
    { district: 'California', atkore: 51.95, zekelman: 22.50, nucor: 11.14 },
    { district: 'Chicago', atkore: 31.18, zekelman: 80.48, nucor: 10.81 },
    { district: 'Dallas', atkore: 75.21, zekelman: 41.02, nucor: 21.48 },
    { district: 'Minneapolis', atkore: 48.31, zekelman: 72.50, nucor: 11.02 },
    { district: 'New York', atkore: 75.46, zekelman: 10.98, nucor: 5.21 },
    { district: 'Pittsburgh', atkore: 63.89, zekelman: 54.58, nucor: 93.89 },
    { district: 'Richmond', atkore: 54.58, zekelman: 73.89, nucor: 23.89 },
    { district: 'Seattle', atkore: 63.89, zekelman: 73.89, nucor: 23.89 },
    { district: 'Tampa', atkore: 64.24, zekelman: 74.58, nucor: 13.89 },
  ],
  tableData: {
    monthlyTL: [
      { district: 'Atlanta', value: 19 },
      { district: 'Boston', value: 12 },
      { district: 'California', value: 10 },
      { district: 'Chicago', value: 14 },
      { district: 'Dallas', value: 24 },
      { district: 'Minneapolis', value: 11 },
      { district: 'New York', value: 8 },
      { district: 'Pittsburgh', value: 12 },
      { district: 'Richmond', value: 8 },
      { district: 'Seattle', value: 7 },
      { district: 'Tampa', value: 15 },
    ],
    suppliersPct: [
      {
        atkore: [
          { district: 'Atlanta', value: 1 },
          { district: 'Boston', value: 6 },
          { district: 'California', value: 32 },
          { district: 'Chicago', value: 8 },
          { district: 'Dallas', value: 52 },
          { district: 'Minneapolis', value: 10 },
          { district: 'New York', value: 2 },
          { district: 'Pittsburgh', value: 20 },
          { district: 'Richmond', value: 0 },
          { district: 'Seattle', value: 0 },
          { district: 'Tampa', value: 5 },
        ],
      },
      {
        zekelman: [
          { district: 'Atlanta', value: 11 },
          { district: 'Boston', value: 97 },
          { district: 'California', value: 8 },
          { district: 'Chicago', value: 32 },
          { district: 'Dallas', value: 8 },
          { district: 'Minneapolis', value: 52 },
          { district: 'New York', value: 10 },
          { district: 'Pittsburgh', value: 80 },
          { district: 'Richmond', value: 66 },
          { district: 'Seattle', value: 95 },
          { district: 'Tampa', value: 66 },
        ],
      },
      {
        nucor: [
          { district: 'Atlanta', value: 95 },
          { district: 'Boston', value: 3 },
          { district: 'California', value: 97 },
          { district: 'Chicago', value: 68 },
          { district: 'Dallas', value: 33 },
          { district: 'Minneapolis', value: 42 },
          { district: 'New York', value: 10 },
          { district: 'Pittsburgh', value: 0 },
          { district: 'Richmond', value: 29 },
          { district: 'Seattle', value: 4 },
          { district: 'Tampa', value: 34 },
        ],
      },
    ],

    vendors: [
      "atkore", "zekelman", "nucor"
    ],
  },
};


export const ALLOWED_PRICE_SKUS = [
  'BARE-Stranded-4/0 AWG',
  'NM-WG-10 AWG-3-C',
  'THHN-Stranded-12 AWG',
  'XHHW-2-Stranded-600 MCM',
  'THHN-Stranded-500 MCM',
  'XLP-USE-Stranded-6 AWG'
];


export const dummyDataForRebate: any = [
  {
    type: "Parent",
    district: "ATL",
    supplier: "Atkore",
    commodity: "All",
    category: "All",
    growthTierType: "Dollar",
    bactToZero: "No",
    dollarPoundToNextTier: 0,
    nextTierBenefit: 0,
    projectPurchaseStart: 3000001,
    projectPurchaseEnd: 5000000,
    tierDetails: [
      {
        tierType: "Base Rebate",
        startValue: 0,
        endValue: 3000000,
        benefitPercentage: 0.5,
        progress: 60,
        projecttion: "On-Pace",
      },
      {
        tierType: "Tier 1",
        startValue: 3000001,
        endValue: 7000000,
        benefitPercentage: 4,
        progress: 40,
        projecttion: "Behind",
      },
    ],
  },
  {
    type: "Others",
    district: "ATL",
    supplier: "Atkore",
    commodity: "Steel",
    category: "Conduit",
    growthTierType: "Dollar",
    bactToZero: "No",
    dollarPoundToNextTier: 55000,
    nextTierBenefit: 2500,
    projectPurchaseStart: 420000,
    projectPurchaseEnd: 465000,
    tierDetails: [
      {
        tierType: "Base Rebate",
        startValue: 0,
        endValue: 1000000,
        benefitPercentage: 3,
        progress: 60,
        projecttion: "On-Pace",
      },
      {
        tierType: "Tier 1",
        startValue: 1000001,
        endValue: 2000000,
        benefitPercentage: 4,
        progress: 40,
        projecttion: "Behind",
      },
    ],
  },
  {
    type: "Others",
    district: "ATL",
    supplier: "Atkore",
    commodity: "Steel",
    category: "Fittings",
    growthTierType: "Dollar",
    bactToZero: "No",
    dollarPoundToNextTier: 60000,
    nextTierBenefit: 3000,
    projectPurchaseStart: 480000,
    projectPurchaseEnd: 520000,
    tierDetails: [
      {
        tierType: "Base Rebate",
        startValue: 0,
        endValue: 1000000,
        benefitPercentage: 3,
        progress: 80,
        projecttion: "On-Pace",
      },
      {
        tierType: "Tier 1",
        startValue: 1000001,
        endValue: 2000000,
        benefitPercentage: 4,
        progress: 55,
        projecttion: "On-Pace",
      },
    ],
  },
  {
    type: "Others",
    district: "ATL",
    showDistrict: false,
    supplier: "Prime",
    commodity: "PVC",
    category: "Conduit",
    growthTierType: "Dollar",
    bactToZero: "No",
    dollarPoundToNextTier: 90000,
    nextTierBenefit: 5000,
    projectPurchaseStart: 1500000,
    projectPurchaseEnd: 2000000,
    tierDetails: [
      {
        tierType: "Base Rebate",
        startValue: 0,
        endValue: 1500000,
        benefitPercentage: 0.5,
        progress: 40,
        projecttion: "Behind",
      },
      {
        tierType: "Tier 1",
        startValue: 1500001,
        endValue: 3000000,
        benefitPercentage: 1.0,
        progress: 10,
        projecttion: "Behind",
      },
    ],
  },
  {
    type: "Others",
    district: "BOS",
    supplier: "Western",
    commodity: "Steel",
    category: "Fittings",
    growthTierType: "Dollar",
    bactToZero: "No",
    dollarPoundToNextTier: 75000,
    nextTierBenefit: 5500,
    projectPurchaseStart: 500000,
    projectPurchaseEnd: 550000,
    tierDetails: [
      {
        tierType: "Base Rebate",
        startValue: 0,
        endValue: 1000000,
        benefitPercentage: 0.5,
        progress: 55,
        projecttion: "Behind",
      },
      {
        tierType: "Tier 1",
        startValue: 1000001,
        endValue: 2000000,
        benefitPercentage: 1.5,
        progress: 20,
        projecttion: "On-Pace",
      },
    ],
  },
  {
    type: "Others",
    district: "BOS",
    supplier: "Prime",
    commodity: "PVC",
    category: "Conduit",
    growthTierType: "Dollar",
    bactToZero: "No",
    dollarPoundToNextTier: 90000,
    nextTierBenefit: 5000,
    projectPurchaseStart: 1500000,
    projectPurchaseEnd: 2000000,
    tierDetails: [
      {
        tierType: "Base Rebate",
        startValue: 0,
        endValue: 1500000,
        benefitPercentage: 0.5,
        progress: 40,
        projecttion: "Behind",
      },
      {
        tierType: "Tier 1",
        startValue: 1500001,
        endValue: 3000000,
        benefitPercentage: 1.0,
        progress: 10,
        projecttion: "Behind",
      },
    ],
  },

  {
    type: "Others",
    district: "RCH",
    supplier: "Prime",
    commodity: "PVC",
    category: "Conduit",
    growthTierType: "Dollar",
    bactToZero: "No",
    dollarPoundToNextTier: 90000,
    nextTierBenefit: 5000,
    projectPurchaseStart: 1500000,
    projectPurchaseEnd: 2000000,
    tierDetails: [
      {
        tierType: "Base Rebate",
        startValue: 0,
        endValue: 1500000,
        benefitPercentage: 0.5,
        progress: 40,
        projecttion: "Behind",
      },
      {
        tierType: "Tier 1",
        startValue: 1500001,
        endValue: 3000000,
        benefitPercentage: 1.0,
        progress: 70,
        projecttion: "Behind",
      },
    ],
  },
  {
    type: "Others",
    district: "RCH",
    showDistrict: false,
    supplier: "Prime",
    commodity: "PVC",
    category: "Conduit",
    growthTierType: "Pound",
    bactToZero: "No",
    dollarPoundToNextTier: 900000,
    nextTierBenefit: 5000,
    projectPurchaseStart: 1000000,
    projectPurchaseEnd: 4000000,
    tierDetails: [
      {
        tierType: "Base Rebate",
        startValue: 0,
        endValue: 1500000,
        benefitPercentage: 0.5,
        progress: 40,
        projecttion: "Behind",
      },
      {
        tierType: "Tier 1",
        startValue: 1500001,
        endValue: 3000000,
        benefitPercentage: 1.0,
        progress: 10,
        projecttion: "Behind",
      },
      {
        tierType: "Tier 3",
        startValue: 3000001,
        endValue: 6000000,
        benefitPercentage: 4.0,
        progress: 60,
        projecttion: "Behind",
      }
    ],
  },
  {
    type: "Parent",
    district: "RCH",
    supplier: "Prime",
    commodity: "PVC",
    category: "Conduit",
    growthTierType: "Pound",
    bactToZero: "No",
    dollarPoundToNextTier: 0,
    nextTierBenefit: 0,
    projectPurchaseStart: 1000000,
    projectPurchaseEnd: 4000000,
    tierDetails: [
      {
        tierType: "Base Rebate",
        startValue: 0,
        endValue: 1500000,
        benefitPercentage: 0.7,
        progress: 40,
        projecttion: "Behind",
      },
      {
        tierType: "Tier 1",
        startValue: 1500001,
        endValue: 3000000,
        benefitPercentage: 2.0,
        progress: 60,
        projecttion: "Behind",
      },
      {
        tierType: "Tier 3",
        startValue: 3000001,
        endValue: 6000000,
        benefitPercentage: 3.0,
        progress: 70,
        projecttion: "Behind",
      }
    ],
  },
];

export const rebateTrackingFiltersData = {
  "commodity": [
    {
      "commodity": "Steel Conduit"
    },
    {
      "commodity": "PVC Conduit"
    },
    {
      "commodity": "Copper Wire"
    }
  ],
  "districts": [
    {
      "district": "Atlanta"
    },
    {
      "district": "Boston"
    },
    {
      "district": "California"
    },
    {
      "district": "Chicago"
    },
    {
      "district": "Dallas"
    },
    {
      "district": "Minneapolis"
    },
    {
      "district": "New York"
    },
    {
      "district": "Pittsburgh"
    },
    {
      "district": "Richmond"
    },
    {
      "district": "Seattle"
    },
    {
      "district": "Southwest"
    },
    {
      "district": "St. Louis"
    },
    {
      "district": "Tampa"
    }
  ],
  "vendor": [
    {
      "vendor": "ATKORE"
    },
    {
      "vendor": "NUCOR"
    },
    {
      "vendor": "ZEKELMAN"
    }
  ],

}

export const quotesummary: any = {
  "ratio_analysis_data": [
    {
      "trade": "THHN",
      "size": "THHN-Stranded-12 AWG",
      "benchmark": 1,
      "atlanta - float": 168.26,
      "atlanta - float_difference": 0,
      "atlanta - float_expected_quote": null,
      "dallas - firm": 175.99,
      "dallas - firm_difference": 0,
      "dallas - firm_expected_quote": null,
      "richmond - spot": 169.92,
      "richmond - spot_difference": 0,
      "richmond - spot_expected_quote": null,
      "seattle - firm": 180.48,
      "seattle - firm_difference": 0,
      "seattle - firm_expected_quote": null,
      "st. louis - firm": 178.66,
      "st. louis - firm_difference": 0,
      "st. louis - firm_expected_quote": null,
      "tampa - spot": 167.43,
      "tampa - spot_difference": 0,
      "tampa - spot_expected_quote": null
    },
    {
      "trade": "SER",
      "size": "SER-1-1-1-3 AWG",
      "benchmark": 55.02,
      "atlanta - float": 9257.51,
      "atlanta - float_difference": 0,
      "atlanta - float_expected_quote": 9257.14,
      "dallas - firm": 9682.6,
      "dallas - firm_difference": 0,
      "dallas - firm_expected_quote": 9682.2,
      "richmond - spot": 9348.99,
      "richmond - spot_difference": 0.01,
      "richmond - spot_expected_quote": 9348.47,
      "seattle - firm": 9929.59,
      "seattle - firm_difference": 0,
      "seattle - firm_expected_quote": 9929.18,
      "st. louis - firm": 9829.84,
      "st. louis - firm_difference": 0,
      "st. louis - firm_expected_quote": 9829.44,
      "tampa - spot": 9211.77,
      "tampa - spot_difference": 0,
      "tampa - spot_expected_quote": 9211.39
    },
    {
      "trade": "SER",
      "size": "SER-1/0-1/0-1/0-2 AWG",
      "benchmark": 69.2,
      "atlanta - float": 11644.33,
      "atlanta - float_difference": 0,
      "atlanta - float_expected_quote": 11643.87,
      "dallas - firm": 12179.02,
      "dallas - firm_difference": 0,
      "dallas - firm_expected_quote": 12178.53,
      "richmond - spot": 11759.4,
      "richmond - spot_difference": 0.01,
      "richmond - spot_expected_quote": 11758.75,
      "seattle - firm": 12489.69,
      "seattle - firm_difference": 0,
      "seattle - firm_expected_quote": 12489.19,
      "st. louis - firm": 12364.22,
      "st. louis - firm_difference": 0,
      "st. louis - firm_expected_quote": 12363.73,
      "tampa - spot": 11586.79,
      "tampa - spot_difference": 0,
      "tampa - spot_expected_quote": 11586.33
    },
    {
      "trade": "SER",
      "size": "SER-2/0-2/0-2/0-1 AWG",
      "benchmark": 85.37,
      "atlanta - float": 14364.41,
      "atlanta - float_difference": 0,
      "atlanta - float_expected_quote": 14363.84,
      "dallas - firm": 15024,
      "dallas - firm_difference": 0,
      "dallas - firm_expected_quote": 15023.38,
      "richmond - spot": 14506.36,
      "richmond - spot_difference": 0.01,
      "richmond - spot_expected_quote": 14505.55,
      "st. louis - firm": 15252.47,
      "st. louis - firm_difference": 0,
      "st. louis - firm_expected_quote": 15251.85,
      "tampa - spot": 14293.43,
      "tampa - spot_difference": 0,
      "tampa - spot_expected_quote": 14292.85
    },
    {
      "trade": "SER",
      "size": "SER-2-2-2-4 AWG",
      "benchmark": 42.35,
      "atlanta - float": 7198.48,
      "atlanta - float_difference": 1.02,
      "atlanta - float_expected_quote": 7125.71,
      "dallas - firm": 7529.02,
      "dallas - firm_difference": 1.02,
      "dallas - firm_expected_quote": 7452.9,
      "richmond - spot": 7269.62,
      "richmond - spot_difference": 1.02,
      "richmond - spot_expected_quote": 7196.01,
      "seattle - firm": 7721.08,
      "seattle - firm_difference": 1.02,
      "seattle - firm_expected_quote": 7643.01,
      "st. louis - firm": 7643.52,
      "st. louis - firm_difference": 1.02,
      "st. louis - firm_expected_quote": 7566.24,
      "tampa - spot": 7162.91,
      "tampa - spot_difference": 1.02,
      "tampa - spot_expected_quote": 7090.49
    },
    {
      "trade": "SER",
      "size": "SER-3-3-3-5 AWG",
      "benchmark": 36.34,
      "atlanta - float": 6177.17,
      "atlanta - float_difference": 1.02,
      "atlanta - float_expected_quote": 6114.71,
      "dallas - firm": 6460.81,
      "dallas - firm_difference": 1.02,
      "dallas - firm_expected_quote": 6395.48,
      "richmond - spot": 6238.21,
      "richmond - spot_difference": 1.02,
      "richmond - spot_expected_quote": 6175.04,
      "seattle - firm": 6625.62,
      "seattle - firm_difference": 1.02,
      "seattle - firm_expected_quote": 6558.62,
      "st. louis - firm": 6559.06,
      "st. louis - firm_difference": 1.02,
      "st. louis - firm_expected_quote": 6492.74,
      "tampa - spot": 6146.64,
      "tampa - spot_difference": 1.02,
      "tampa - spot_expected_quote": 6084.49
    },
    {
      "trade": "SER",
      "size": "SER-3/0-3/0-3/0-1/0 AWG",
      "benchmark": 107.05,
      "atlanta - float": 18012.27,
      "atlanta - float_difference": 0,
      "atlanta - float_expected_quote": 18012.27,
      "dallas - firm": 18839.37,
      "dallas - firm_difference": 0,
      "dallas - firm_expected_quote": 18839.34,
      "richmond - spot": 18190.27,
      "richmond - spot_difference": 0,
      "richmond - spot_expected_quote": 18189.97,
      "seattle - firm": 19319.94,
      "seattle - firm_difference": 0,
      "seattle - firm_expected_quote": 19319.91,
      "st. louis - firm": 19125.86,
      "st. louis - firm_difference": 0,
      "st. louis - firm_expected_quote": 19125.83,
      "tampa - spot": 17923.27,
      "tampa - spot_difference": 0,
      "tampa - spot_expected_quote": 17923.25
    },
    {
      "trade": "SER",
      "size": "SER-6-6-6-6 AWG",
      "benchmark": 25.46,
      "atlanta - float": 4327.18,
      "atlanta - float_difference": 1.02,
      "atlanta - float_expected_quote": 4283.43,
      "dallas - firm": 4525.88,
      "dallas - firm_difference": 1.02,
      "dallas - firm_expected_quote": 4480.11,
      "richmond - spot": 4369.94,
      "richmond - spot_difference": 1.02,
      "richmond - spot_expected_quote": 4325.69,
      "seattle - firm": 4641.33,
      "seattle - firm_difference": 1.02,
      "seattle - firm_expected_quote": 4594.39,
      "st. louis - firm": 4594.7,
      "st. louis - firm_difference": 1.02,
      "st. louis - firm_expected_quote": 4548.24,
      "tampa - spot": 4305.8,
      "tampa - spot_difference": 1.02,
      "tampa - spot_expected_quote": 4262.26
    },
    {
      "trade": "SER",
      "size": "SER-4-4-4-6 AWG",
      "benchmark": 27.04,
      "atlanta - float": 4595.78,
      "atlanta - float_difference": 1.02,
      "atlanta - float_expected_quote": 4549.31,
      "dallas - firm": 4806.81,
      "dallas - firm_difference": 1.02,
      "dallas - firm_expected_quote": 4758.2,
      "richmond - spot": 4641.19,
      "richmond - spot_difference": 1.02,
      "richmond - spot_expected_quote": 4594.19,
      "seattle - firm": 4929.42,
      "seattle - firm_difference": 1.02,
      "seattle - firm_expected_quote": 4879.58,
      "st. louis - firm": 4879.91,
      "st. louis - firm_difference": 1.02,
      "st. louis - firm_expected_quote": 4830.56,
      "tampa - spot": 4573.07,
      "tampa - spot_difference": 1.02,
      "tampa - spot_expected_quote": 4526.83
    },
    {
      "trade": "SEU",
      "size": "SEU-1/0-1/0-1/0 AWG",
      "benchmark": 55.73,
      "atlanta - float": 9377.59,
      "atlanta - float_difference": 0,
      "atlanta - float_expected_quote": 9377.59,
      "dallas - firm": 9808.19,
      "dallas - firm_difference": 0,
      "dallas - firm_expected_quote": 9808.18,
      "richmond - spot": 9470.26,
      "richmond - spot_difference": 0,
      "richmond - spot_expected_quote": 9470.11,
      "st. louis - firm": 9957.35,
      "st. louis - firm_difference": 0,
      "st. louis - firm_expected_quote": 9957.34,
      "tampa - spot": 9331.26,
      "tampa - spot_difference": 0,
      "tampa - spot_expected_quote": 9331.24
    },
    {
      "trade": "SEU",
      "size": "SEU-10-10-10 AWG",
      "benchmark": 6.72,
      "atlanta - float": 1131.57,
      "atlanta - float_difference": 0,
      "atlanta - float_expected_quote": 1131.53,
      "dallas - firm": 1183.53,
      "dallas - firm_difference": 0,
      "dallas - firm_expected_quote": 1183.48,
      "richmond - spot": 1142.75,
      "richmond - spot_difference": 0.01,
      "richmond - spot_expected_quote": 1142.69,
      "seattle - firm": 1213.72,
      "seattle - firm_difference": 0,
      "seattle - firm_expected_quote": 1213.67,
      "st. louis - firm": 1201.53,
      "st. louis - firm_difference": 0,
      "st. louis - firm_expected_quote": 1201.48,
      "tampa - spot": 1125.98,
      "tampa - spot_difference": 0,
      "tampa - spot_expected_quote": 1125.93
    },
    {
      "trade": "SEU",
      "size": "SEU-2-2-2 AWG",
      "benchmark": 29.57,
      "atlanta - float": 5025.99,
      "atlanta - float_difference": 1.02,
      "atlanta - float_expected_quote": 4975.18,
      "dallas - firm": 5256.78,
      "dallas - firm_difference": 1.02,
      "dallas - firm_expected_quote": 5203.62,
      "richmond - spot": 5075.66,
      "richmond - spot_difference": 1.02,
      "richmond - spot_expected_quote": 5024.26,
      "st. louis - firm": 5336.72,
      "st. louis - firm_difference": 1.02,
      "st. louis - firm_expected_quote": 5282.76,
      "tampa - spot": 5001.16,
      "tampa - spot_difference": 1.02,
      "tampa - spot_expected_quote": 4950.59
    },
    {
      "trade": "SEU",
      "size": "SEU-2-2-4 AWG",
      "benchmark": 25.67,
      "atlanta - float": 4363.78,
      "atlanta - float_difference": 1.02,
      "atlanta - float_expected_quote": 4319.66,
      "dallas - firm": 4564.16,
      "dallas - firm_difference": 1.02,
      "dallas - firm_expected_quote": 4518.01,
      "richmond - spot": 4406.91,
      "richmond - spot_difference": 1.02,
      "richmond - spot_expected_quote": 4362.28,
      "st. louis - firm": 4633.57,
      "st. louis - firm_difference": 1.02,
      "st. louis - firm_expected_quote": 4586.72,
      "tampa - spot": 4342.22,
      "tampa - spot_difference": 1.02,
      "tampa - spot_expected_quote": 4298.32
    },
    {
      "trade": "SEU",
      "size": "SEU-2/0-2/0-2/0 AWG",
      "benchmark": 61.78,
      "atlanta - float": 10396,
      "atlanta - float_difference": 0,
      "atlanta - float_expected_quote": 10395.59,
      "dallas - firm": 10873.37,
      "dallas - firm_difference": 0,
      "dallas - firm_expected_quote": 10872.92,
      "richmond - spot": 10498.73,
      "richmond - spot_difference": 0.01,
      "richmond - spot_expected_quote": 10498.15,
      "seattle - firm": 11150.74,
      "seattle - firm_difference": 0,
      "seattle - firm_expected_quote": 11150.28,
      "st. louis - firm": 11038.72,
      "st. louis - firm_difference": 0,
      "st. louis - firm_expected_quote": 11038.27,
      "tampa - spot": 10344.63,
      "tampa - spot_difference": 0,
      "tampa - spot_expected_quote": 10344.21
    },
    {
      "trade": "SEU",
      "size": "SEU-3-3-5 AWG",
      "benchmark": 21.42,
      "atlanta - float": 4047.64,
      "atlanta - float_difference": 12.29,
      "atlanta - float_expected_quote": 3604.64,
      "dallas - firm": 4233.5,
      "dallas - firm_difference": 12.29,
      "dallas - firm_expected_quote": 3770.15,
      "richmond - spot": 4087.64,
      "richmond - spot_difference": 12.29,
      "richmond - spot_expected_quote": 3640.2,
      "st. louis - firm": 4297.88,
      "st. louis - firm_difference": 12.29,
      "st. louis - firm_expected_quote": 3827.48,
      "tampa - spot": 4027.64,
      "tampa - spot_difference": 12.29,
      "tampa - spot_expected_quote": 3586.82
    },
    {
      "trade": "SEU",
      "size": "SEU-3/0-3/0-3/0 AWG",
      "benchmark": 80.97,
      "atlanta - float": 13624.57,
      "atlanta - float_difference": 0,
      "atlanta - float_expected_quote": 13624.57,
      "dallas - firm": 14250.19,
      "dallas - firm_difference": 0,
      "dallas - firm_expected_quote": 14250.17,
      "richmond - spot": 13759.21,
      "richmond - spot_difference": 0,
      "richmond - spot_expected_quote": 13758.99,
      "st. louis - firm": 14466.89,
      "st. louis - firm_difference": 0,
      "st. louis - firm_expected_quote": 14466.87,
      "tampa - spot": 13557.25,
      "tampa - spot_difference": 0,
      "tampa - spot_expected_quote": 13557.23
    },
    {
      "trade": "SEU",
      "size": "SEU-4-4-4 AWG",
      "benchmark": 18.99,
      "atlanta - float": 3228.73,
      "atlanta - float_difference": 1.02,
      "atlanta - float_expected_quote": 3196.09,
      "dallas - firm": 3376.99,
      "dallas - firm_difference": 1.02,
      "dallas - firm_expected_quote": 3342.85,
      "richmond - spot": 3260.64,
      "richmond - spot_difference": 1.02,
      "richmond - spot_expected_quote": 3227.62,
      "seattle - firm": 3463.13,
      "seattle - firm_difference": 1.02,
      "seattle - firm_expected_quote": 3428.12,
      "st. louis - firm": 3428.35,
      "st. louis - firm_difference": 1.02,
      "st. louis - firm_expected_quote": 3393.68,
      "tampa - spot": 3212.78,
      "tampa - spot_difference": 1.02,
      "tampa - spot_expected_quote": 3180.3
    },
    {
      "trade": "SEU",
      "size": "SEU-4-4-6 AWG",
      "benchmark": 16.84,
      "atlanta - float": 2862.79,
      "atlanta - float_difference": 1.02,
      "atlanta - float_expected_quote": 2833.85,
      "dallas - firm": 2994.25,
      "dallas - firm_difference": 1.02,
      "dallas - firm_expected_quote": 2963.97,
      "richmond - spot": 2891.08,
      "richmond - spot_difference": 1.02,
      "richmond - spot_expected_quote": 2861.81,
      "seattle - firm": 3070.63,
      "seattle - firm_difference": 1.02,
      "seattle - firm_expected_quote": 3039.58,
      "st. louis - firm": 3039.78,
      "st. louis - firm_difference": 1.02,
      "st. louis - firm_expected_quote": 3009.05,
      "tampa - spot": 2848.65,
      "tampa - spot_difference": 1.02,
      "tampa - spot_expected_quote": 2819.85
    },
    {
      "trade": "SEU",
      "size": "SEU-6-6-6 AWG",
      "benchmark": 12.11,
      "atlanta - float": 2058.6,
      "atlanta - float_difference": 1.02,
      "atlanta - float_expected_quote": 2037.79,
      "dallas - firm": 2153.13,
      "dallas - firm_difference": 1.02,
      "dallas - firm_expected_quote": 2131.36,
      "richmond - spot": 2078.94,
      "richmond - spot_difference": 1.02,
      "richmond - spot_expected_quote": 2057.9,
      "seattle - firm": 2208.05,
      "seattle - firm_difference": 1.02,
      "seattle - firm_expected_quote": 2185.73,
      "st. louis - firm": 2185.87,
      "st. louis - firm_difference": 1.02,
      "st. louis - firm_expected_quote": 2163.77,
      "tampa - spot": 2048.43,
      "tampa - spot_difference": 1.02,
      "tampa - spot_expected_quote": 2027.72
    },
    {
      "trade": "SEU",
      "size": "SEU-6-6-8 AWG",
      "benchmark": 10.65,
      "atlanta - float": 1810.84,
      "atlanta - float_difference": 1.02,
      "atlanta - float_expected_quote": 1792.54,
      "dallas - firm": 1893.99,
      "dallas - firm_difference": 1.02,
      "dallas - firm_expected_quote": 1874.85,
      "richmond - spot": 1828.73,
      "richmond - spot_difference": 1.02,
      "richmond - spot_expected_quote": 1810.22,
      "seattle - firm": 1942.3,
      "seattle - firm_difference": 1.02,
      "seattle - firm_expected_quote": 1922.67,
      "st. louis - firm": 1922.79,
      "st. louis - firm_difference": 1.02,
      "st. louis - firm_expected_quote": 1903.36,
      "tampa - spot": 1801.89,
      "tampa - spot_difference": 1.02,
      "tampa - spot_expected_quote": 1783.68
    },
    {
      "trade": "SEU",
      "size": "SEU-8-8-8 AWG",
      "benchmark": 8.01,
      "atlanta - float": 1361.14,
      "atlanta - float_difference": 1.02,
      "atlanta - float_expected_quote": 1347.37,
      "dallas - firm": 1423.64,
      "dallas - firm_difference": 1.02,
      "dallas - firm_expected_quote": 1409.23,
      "richmond - spot": 1374.59,
      "richmond - spot_difference": 1.02,
      "richmond - spot_expected_quote": 1360.66,
      "seattle - firm": 1459.95,
      "seattle - firm_difference": 1.02,
      "seattle - firm_expected_quote": 1445.18,
      "st. louis - firm": 1445.29,
      "st. louis - firm_difference": 1.02,
      "st. louis - firm_expected_quote": 1430.66,
      "tampa - spot": 1354.41,
      "tampa - spot_difference": 1.02,
      "tampa - spot_expected_quote": 1340.71
    },
    {
      "trade": "TFFN",
      "size": "TFFN-Stranded-16 AWG",
      "benchmark": 0.51,
      "atlanta - float": 86.56,
      "atlanta - float_difference": 0.01,
      "atlanta - float_expected_quote": 86.55,
      "dallas - firm": 90.53,
      "dallas - firm_difference": 0.01,
      "dallas - firm_expected_quote": 90.52,
      "seattle - firm": 92.84,
      "seattle - firm_difference": 0.01,
      "seattle - firm_expected_quote": 92.83,
      "st. louis - firm": 91.91,
      "st. louis - firm_difference": 0.01,
      "st. louis - firm_expected_quote": 91.9,
      "tampa - spot": 86.13,
      "tampa - spot_difference": 0.01,
      "tampa - spot_expected_quote": 86.12
    },
    {
      "trade": "TFFN",
      "size": "TFFN-Stranded-18 AWG",
      "benchmark": 0.37,
      "atlanta - float": 61.86,
      "atlanta - float_difference": 0.01,
      "atlanta - float_expected_quote": 61.85,
      "dallas - firm": 64.7,
      "dallas - firm_difference": 0.02,
      "dallas - firm_expected_quote": 64.69,
      "seattle - firm": 66.35,
      "seattle - firm_difference": 0.02,
      "seattle - firm_expected_quote": 66.34,
      "st. louis - firm": 65.69,
      "st. louis - firm_difference": 0.02,
      "st. louis - firm_expected_quote": 65.68,
      "tampa - spot": 61.56,
      "tampa - spot_difference": 0.02,
      "tampa - spot_expected_quote": 61.55
    },
    {
      "trade": "TFN",
      "size": "TFN-Solid-16 AWG",
      "benchmark": 0.42,
      "atlanta - float": 70.38,
      "atlanta - float_difference": 0,
      "atlanta - float_expected_quote": 70.38,
      "dallas - firm": 73.61,
      "dallas - firm_difference": 0,
      "dallas - firm_expected_quote": 73.61,
      "seattle - firm": 75.49,
      "seattle - firm_difference": 0,
      "seattle - firm_expected_quote": 75.49,
      "st. louis - firm": 74.73,
      "st. louis - firm_difference": 0,
      "st. louis - firm_expected_quote": 74.73,
      "tampa - spot": 70.03,
      "tampa - spot_difference": 0,
      "tampa - spot_expected_quote": 70.03
    },
    {
      "trade": "TFN",
      "size": "TFN-Solid-18 AWG",
      "benchmark": 0.3,
      "atlanta - float": 50.71,
      "atlanta - float_difference": 0,
      "atlanta - float_expected_quote": 50.71,
      "dallas - firm": 53.04,
      "dallas - firm_difference": 0,
      "dallas - firm_expected_quote": 53.04,
      "seattle - firm": 54.39,
      "seattle - firm_difference": 0,
      "seattle - firm_expected_quote": 54.39,
      "st. louis - firm": 53.85,
      "st. louis - firm_difference": 0,
      "st. louis - firm_expected_quote": 53.85,
      "tampa - spot": 50.46,
      "tampa - spot_difference": 0,
      "tampa - spot_expected_quote": 50.46
    },
    {
      "trade": "THHN",
      "size": "THHN-Solid-10 AWG",
      "benchmark": 1.46,
      "atlanta - float": 245.75,
      "atlanta - float_difference": 0.01,
      "atlanta - float_expected_quote": 245.72,
      "dallas - firm": 257.03,
      "dallas - firm_difference": 0.01,
      "dallas - firm_expected_quote": 257,
      "richmond - spot": 248.18,
      "richmond - spot_difference": 0.01,
      "richmond - spot_expected_quote": 248.14,
      "seattle - firm": 263.59,
      "seattle - firm_difference": 0.01,
      "seattle - firm_expected_quote": 263.56,
      "st. louis - firm": 260.94,
      "st. louis - firm_difference": 0.01,
      "st. louis - firm_expected_quote": 260.91,
      "tampa - spot": 244.53,
      "tampa - spot_difference": 0.01,
      "tampa - spot_expected_quote": 244.51
    },
    {
      "trade": "THHN",
      "size": "THHN-Solid-12 AWG",
      "benchmark": 0.93,
      "atlanta - float": 157.07,
      "atlanta - float_difference": 0,
      "atlanta - float_expected_quote": 157.06,
      "dallas - firm": 164.29,
      "dallas - firm_difference": 0.01,
      "dallas - firm_expected_quote": 164.28,
      "richmond - spot": 158.63,
      "richmond - spot_difference": 0.01,
      "richmond - spot_expected_quote": 158.61,
      "seattle - firm": 168.48,
      "seattle - firm_difference": 0.01,
      "seattle - firm_expected_quote": 168.47,
      "st. louis - firm": 166.78,
      "st. louis - firm_difference": 0.01,
      "st. louis - firm_expected_quote": 166.77,
      "tampa - spot": 156.3,
      "tampa - spot_difference": 0.01,
      "tampa - spot_expected_quote": 156.29
    },
    {
      "trade": "THHN",
      "size": "THHN-Solid-14 AWG",
      "benchmark": 0.61,
      "atlanta - float": 102.38,
      "atlanta - float_difference": 0,
      "atlanta - float_expected_quote": 102.38,
      "dallas - firm": 107.08,
      "dallas - firm_difference": 0,
      "dallas - firm_expected_quote": 107.08,
      "richmond - spot": 103.39,
      "richmond - spot_difference": 0,
      "richmond - spot_expected_quote": 103.39,
      "seattle - firm": 109.81,
      "seattle - firm_difference": 0,
      "seattle - firm_expected_quote": 109.81,
      "st. louis - firm": 108.71,
      "st. louis - firm_difference": 0,
      "st. louis - firm_expected_quote": 108.7,
      "tampa - spot": 101.87,
      "tampa - spot_difference": 0,
      "tampa - spot_expected_quote": 101.87
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-1 AWG",
      "benchmark": 11.54,
      "atlanta - float": 2035.2,
      "atlanta - float_difference": 4.82,
      "atlanta - float_expected_quote": 1941.68,
      "dallas - firm": 2128.65,
      "dallas - firm_difference": 4.82,
      "dallas - firm_expected_quote": 2030.84,
      "richmond - spot": 2055.31,
      "richmond - spot_difference": 4.82,
      "richmond - spot_expected_quote": 1960.84,
      "seattle - firm": 2182.95,
      "seattle - firm_difference": 4.82,
      "seattle - firm_expected_quote": 2082.64,
      "st. louis - firm": 2161.02,
      "st. louis - firm_difference": 4.82,
      "st. louis - firm_expected_quote": 2061.72,
      "tampa - spot": 2025.14,
      "tampa - spot_difference": 4.82,
      "tampa - spot_expected_quote": 1932.08
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-1/0 AWG",
      "benchmark": 14.13,
      "atlanta - float": 2491.77,
      "atlanta - float_difference": 4.82,
      "atlanta - float_expected_quote": 2377.25,
      "dallas - firm": 2606.19,
      "dallas - firm_difference": 4.82,
      "dallas - firm_expected_quote": 2486.41,
      "richmond - spot": 2516.4,
      "richmond - spot_difference": 4.82,
      "richmond - spot_expected_quote": 2400.71,
      "seattle - firm": 2672.67,
      "seattle - firm_difference": 4.82,
      "seattle - firm_expected_quote": 2549.83,
      "st. louis - firm": 2645.83,
      "st. louis - firm_difference": 4.82,
      "st. louis - firm_expected_quote": 2524.22,
      "tampa - spot": 2479.46,
      "tampa - spot_difference": 4.82,
      "tampa - spot_expected_quote": 2365.5
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-10 AWG",
      "benchmark": 1.53,
      "atlanta - float": 257.36,
      "atlanta - float_difference": 0.01,
      "atlanta - float_expected_quote": 257.33,
      "dallas - firm": 269.18,
      "dallas - firm_difference": 0.01,
      "dallas - firm_expected_quote": 269.14,
      "richmond - spot": 259.91,
      "richmond - spot_difference": 0.02,
      "richmond - spot_expected_quote": 259.87,
      "seattle - firm": 276.05,
      "seattle - firm_difference": 0.01,
      "seattle - firm_expected_quote": 276.01,
      "st. louis - firm": 273.28,
      "st. louis - firm_difference": 0.01,
      "st. louis - firm_expected_quote": 273.24,
      "tampa - spot": 256.09,
      "tampa - spot_difference": 0.01,
      "tampa - spot_expected_quote": 256.06
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-1000 MCM",
      "benchmark": 179.24,
      "atlanta - float": 31611.27,
      "atlanta - float_difference": 4.82,
      "atlanta - float_expected_quote": 30158.92,
      "dallas - firm": 33062.81,
      "dallas - firm_difference": 4.82,
      "dallas - firm_expected_quote": 31543.73,
      "richmond - spot": 31923.65,
      "richmond - spot_difference": 4.82,
      "richmond - spot_expected_quote": 30456.46,
      "st. louis - firm": 33565.6,
      "st. louis - firm_difference": 4.82,
      "st. louis - firm_expected_quote": 32023.42,
      "tampa - spot": 31455.08,
      "tampa - spot_difference": 4.82,
      "tampa - spot_expected_quote": 30009.87
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-14 AWG",
      "benchmark": 0.68,
      "atlanta - float": 113.87,
      "atlanta - float_difference": 0.02,
      "atlanta - float_expected_quote": 113.85,
      "dallas - firm": 119.1,
      "dallas - firm_difference": 0.01,
      "dallas - firm_expected_quote": 119.08,
      "richmond - spot": 114.99,
      "richmond - spot_difference": 0.01,
      "richmond - spot_expected_quote": 114.98,
      "seattle - firm": 122.14,
      "seattle - firm_difference": 0.01,
      "seattle - firm_expected_quote": 122.12,
      "st. louis - firm": 120.91,
      "st. louis - firm_difference": 0.01,
      "st. louis - firm_expected_quote": 120.89,
      "tampa - spot": 113.31,
      "tampa - spot_difference": 0.01,
      "tampa - spot_expected_quote": 113.29
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-2 AWG",
      "benchmark": 10.32,
      "atlanta - float": 1775.69,
      "atlanta - float_difference": 2.26,
      "atlanta - float_expected_quote": 1736.39,
      "dallas - firm": 1857.22,
      "dallas - firm_difference": 2.26,
      "dallas - firm_expected_quote": 1816.12,
      "richmond - spot": 1793.23,
      "richmond - spot_difference": 2.26,
      "richmond - spot_expected_quote": 1753.52,
      "seattle - firm": 1904.6,
      "seattle - firm_difference": 2.26,
      "seattle - firm_expected_quote": 1862.45,
      "st. louis - firm": 1885.47,
      "st. louis - firm_difference": 2.26,
      "st. louis - firm_expected_quote": 1843.74,
      "tampa - spot": 1766.91,
      "tampa - spot_difference": 2.26,
      "tampa - spot_expected_quote": 1727.81
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-2/0 AWG",
      "benchmark": 17.4,
      "atlanta - float": 3069.39,
      "atlanta - float_difference": 4.82,
      "atlanta - float_expected_quote": 2928.34,
      "dallas - firm": 3210.33,
      "dallas - firm_difference": 4.82,
      "dallas - firm_expected_quote": 3062.8,
      "richmond - spot": 3099.72,
      "richmond - spot_difference": 4.82,
      "richmond - spot_expected_quote": 2957.23,
      "seattle - firm": 3292.22,
      "seattle - firm_difference": 4.82,
      "seattle - firm_expected_quote": 3140.93,
      "st. louis - firm": 3259.15,
      "st. louis - firm_difference": 4.82,
      "st. louis - firm_expected_quote": 3109.38,
      "tampa - spot": 3054.22,
      "tampa - spot_difference": 4.82,
      "tampa - spot_expected_quote": 2913.87
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-250 MCM",
      "benchmark": 31.77,
      "atlanta - float": 5602.97,
      "atlanta - float_difference": 4.82,
      "atlanta - float_expected_quote": 5345.54,
      "dallas - firm": 5860.24,
      "dallas - firm_difference": 4.82,
      "dallas - firm_expected_quote": 5590.99,
      "richmond - spot": 5658.33,
      "richmond - spot_difference": 4.82,
      "richmond - spot_expected_quote": 5398.28,
      "seattle - firm": 6009.73,
      "seattle - firm_difference": 4.82,
      "seattle - firm_expected_quote": 5733.61,
      "st. louis - firm": 5949.36,
      "st. louis - firm_difference": 4.82,
      "st. louis - firm_expected_quote": 5676.01,
      "tampa - spot": 5575.28,
      "tampa - spot_difference": 4.82,
      "tampa - spot_expected_quote": 5319.12
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-3 AWG",
      "benchmark": 8.24,
      "atlanta - float": 1418.64,
      "atlanta - float_difference": 2.26,
      "atlanta - float_expected_quote": 1387.23,
      "dallas - firm": 1483.78,
      "dallas - firm_difference": 2.26,
      "dallas - firm_expected_quote": 1450.93,
      "richmond - spot": 1432.66,
      "richmond - spot_difference": 2.27,
      "richmond - spot_expected_quote": 1400.91,
      "seattle - firm": 1521.63,
      "seattle - firm_difference": 2.26,
      "seattle - firm_expected_quote": 1487.94,
      "st. louis - firm": 1506.34,
      "st. louis - firm_difference": 2.26,
      "st. louis - firm_expected_quote": 1472.99,
      "tampa - spot": 1411.63,
      "tampa - spot_difference": 2.26,
      "tampa - spot_expected_quote": 1380.37
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-3/0 AWG",
      "benchmark": 21.96,
      "atlanta - float": 3873.66,
      "atlanta - float_difference": 4.82,
      "atlanta - float_expected_quote": 3695.69,
      "dallas - firm": 4051.53,
      "dallas - firm_difference": 4.82,
      "dallas - firm_expected_quote": 3865.39,
      "richmond - spot": 3911.94,
      "richmond - spot_difference": 4.82,
      "richmond - spot_expected_quote": 3732.16,
      "seattle - firm": 4154.88,
      "seattle - firm_difference": 4.82,
      "seattle - firm_expected_quote": 3963.99,
      "st. louis - firm": 4113.15,
      "st. louis - firm_difference": 4.82,
      "st. louis - firm_expected_quote": 3924.17,
      "tampa - spot": 3854.52,
      "tampa - spot_difference": 4.82,
      "tampa - spot_expected_quote": 3677.43
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-300 MCM",
      "benchmark": 38.1,
      "atlanta - float": 6719.34,
      "atlanta - float_difference": 4.82,
      "atlanta - float_expected_quote": 6410.63,
      "dallas - firm": 7027.88,
      "dallas - firm_difference": 4.82,
      "dallas - firm_expected_quote": 6704.98,
      "richmond - spot": 6785.74,
      "richmond - spot_difference": 4.82,
      "richmond - spot_expected_quote": 6473.87,
      "seattle - firm": 7207.15,
      "seattle - firm_difference": 4.82,
      "seattle - firm_expected_quote": 6876.02,
      "st. louis - firm": 7134.75,
      "st. louis - firm_difference": 4.82,
      "st. louis - firm_expected_quote": 6806.95,
      "tampa - spot": 6686.14,
      "tampa - spot_difference": 4.82,
      "tampa - spot_expected_quote": 6378.94
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-350 MCM",
      "benchmark": 44.61,
      "atlanta - float": 7867.71,
      "atlanta - float_difference": 4.82,
      "atlanta - float_expected_quote": 7506.2,
      "dallas - firm": 8228.99,
      "dallas - firm_difference": 4.82,
      "dallas - firm_expected_quote": 7850.86,
      "richmond - spot": 7945.46,
      "richmond - spot_difference": 4.82,
      "richmond - spot_expected_quote": 7580.25,
      "seattle - firm": 8438.9,
      "seattle - firm_difference": 4.82,
      "seattle - firm_expected_quote": 8051.13,
      "st. louis - firm": 8354.13,
      "st. louis - firm_difference": 4.82,
      "st. louis - firm_expected_quote": 7970.25,
      "tampa - spot": 7828.84,
      "tampa - spot_difference": 4.82,
      "tampa - spot_expected_quote": 7469.1
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-4 AWG",
      "benchmark": 6.54,
      "atlanta - float": 1124.72,
      "atlanta - float_difference": 2.26,
      "atlanta - float_expected_quote": 1099.86,
      "dallas - firm": 1176.37,
      "dallas - firm_difference": 2.26,
      "dallas - firm_expected_quote": 1150.36,
      "richmond - spot": 1135.84,
      "richmond - spot_difference": 2.26,
      "richmond - spot_expected_quote": 1110.71,
      "seattle - firm": 1206.38,
      "seattle - firm_difference": 2.26,
      "seattle - firm_expected_quote": 1179.7,
      "st. louis - firm": 1194.26,
      "st. louis - firm_difference": 2.26,
      "st. louis - firm_expected_quote": 1167.85,
      "tampa - spot": 1119.17,
      "tampa - spot_difference": 2.26,
      "tampa - spot_expected_quote": 1094.42
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-4/0 AWG",
      "benchmark": 27.42,
      "atlanta - float": 4835.34,
      "atlanta - float_difference": 4.82,
      "atlanta - float_expected_quote": 4613.2,
      "dallas - firm": 5057.37,
      "dallas - firm_difference": 4.82,
      "dallas - firm_expected_quote": 4825.02,
      "richmond - spot": 4883.13,
      "richmond - spot_difference": 4.82,
      "richmond - spot_expected_quote": 4658.71,
      "seattle - firm": 5186.38,
      "seattle - firm_difference": 4.82,
      "seattle - firm_expected_quote": 4948.1,
      "st. louis - firm": 5134.28,
      "st. louis - firm_difference": 4.82,
      "st. louis - firm_expected_quote": 4898.39,
      "tampa - spot": 4811.45,
      "tampa - spot_difference": 4.82,
      "tampa - spot_expected_quote": 4590.4
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-400 MCM",
      "benchmark": 50.75,
      "atlanta - float": 8949.92,
      "atlanta - float_difference": 4.82,
      "atlanta - float_expected_quote": 8538.73,
      "dallas - firm": 9360.89,
      "dallas - firm_difference": 4.82,
      "dallas - firm_expected_quote": 8930.8,
      "richmond - spot": 9038.36,
      "richmond - spot_difference": 4.82,
      "richmond - spot_expected_quote": 8622.97,
      "seattle - firm": 9599.67,
      "seattle - firm_difference": 4.82,
      "seattle - firm_expected_quote": 9158.62,
      "st. louis - firm": 9503.24,
      "st. louis - firm_difference": 4.82,
      "st. louis - firm_expected_quote": 9066.62,
      "tampa - spot": 8905.7,
      "tampa - spot_difference": 4.82,
      "tampa - spot_expected_quote": 8496.53
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-500 MCM",
      "benchmark": 64.12,
      "atlanta - float": 11308.89,
      "atlanta - float_difference": 4.82,
      "atlanta - float_expected_quote": 10789.31,
      "dallas - firm": 11828.17,
      "dallas - firm_difference": 4.82,
      "dallas - firm_expected_quote": 11284.73,
      "richmond - spot": 11420.64,
      "richmond - spot_difference": 4.82,
      "richmond - spot_expected_quote": 10895.76,
      "seattle - firm": 12129.9,
      "seattle - firm_difference": 4.82,
      "seattle - firm_expected_quote": 11572.59,
      "st. louis - firm": 12008.05,
      "st. louis - firm_difference": 4.82,
      "st. louis - firm_expected_quote": 11456.34,
      "tampa - spot": 11253.01,
      "tampa - spot_difference": 4.82,
      "tampa - spot_expected_quote": 10735.99
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-6 AWG",
      "benchmark": 4.27,
      "atlanta - float": 734.98,
      "atlanta - float_difference": 2.26,
      "atlanta - float_expected_quote": 718.71,
      "dallas - firm": 768.73,
      "dallas - firm_difference": 2.26,
      "dallas - firm_expected_quote": 751.71,
      "richmond - spot": 742.24,
      "richmond - spot_difference": 2.26,
      "richmond - spot_expected_quote": 725.8,
      "seattle - firm": 788.34,
      "seattle - firm_difference": 2.26,
      "seattle - firm_expected_quote": 770.89,
      "st. louis - firm": 780.42,
      "st. louis - firm_difference": 2.26,
      "st. louis - firm_expected_quote": 763.14,
      "tampa - spot": 731.35,
      "tampa - spot_difference": 2.26,
      "tampa - spot_expected_quote": 715.16
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-600 MCM",
      "benchmark": 79.9,
      "atlanta - float": 14091.95,
      "atlanta - float_difference": 4.82,
      "atlanta - float_expected_quote": 13444.51,
      "dallas - firm": 14739.03,
      "dallas - firm_difference": 4.82,
      "dallas - firm_expected_quote": 14061.84,
      "richmond - spot": 14231.21,
      "richmond - spot_difference": 4.82,
      "richmond - spot_expected_quote": 13577.15,
      "seattle - firm": 15115,
      "seattle - firm_difference": 4.82,
      "seattle - firm_expected_quote": 14420.54,
      "st. louis - firm": 14963.17,
      "st. louis - firm_difference": 4.82,
      "st. louis - firm_expected_quote": 14275.68,
      "tampa - spot": 14022.32,
      "tampa - spot_difference": 4.82,
      "tampa - spot_expected_quote": 13378.06
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-750 MCM",
      "benchmark": 135.07,
      "atlanta - float": 23820.83,
      "atlanta - float_difference": 4.82,
      "atlanta - float_expected_quote": 22726.4,
      "dallas - firm": 24914.64,
      "dallas - firm_difference": 4.82,
      "dallas - firm_expected_quote": 23769.93,
      "richmond - spot": 24056.22,
      "richmond - spot_difference": 4.82,
      "richmond - spot_expected_quote": 22950.62,
      "seattle - firm": 25550.18,
      "seattle - firm_difference": 4.82,
      "seattle - firm_expected_quote": 24376.28,
      "st. louis - firm": 25293.52,
      "st. louis - firm_difference": 4.82,
      "st. louis - firm_expected_quote": 24131.41,
      "tampa - spot": 23703.13,
      "tampa - spot_difference": 4.82,
      "tampa - spot_expected_quote": 22614.08
    },
    {
      "trade": "THHN",
      "size": "THHN-Stranded-8 AWG",
      "benchmark": 2.66,
      "atlanta - float": 477.71,
      "atlanta - float_difference": 6.71,
      "atlanta - float_expected_quote": 447.66,
      "dallas - firm": 499.64,
      "dallas - firm_difference": 6.71,
      "dallas - firm_expected_quote": 468.22,
      "richmond - spot": 482.43,
      "richmond - spot_difference": 6.71,
      "richmond - spot_expected_quote": 452.08,
      "seattle - firm": 512.39,
      "seattle - firm_difference": 6.71,
      "seattle - firm_expected_quote": 480.16,
      "st. louis - firm": 507.24,
      "st. louis - firm_difference": 6.71,
      "st. louis - firm_expected_quote": 475.34,
      "tampa - spot": 475.35,
      "tampa - spot_difference": 6.71,
      "tampa - spot_expected_quote": 445.45
    }
  ],
  "vendorSummary": {
    "St. Louis - Firm": {
      "contract_validity": "Monthly",
      "contract_id": "WQ-130",
      "quotation_start_date": "2026-03-16T00:00:00.000Z"
    },
    "Atlanta - Float": {
      "contract_validity": "Monthly",
      "contract_id": "WQ-153",
      "quotation_start_date": "2026-03-23T00:00:00.000Z"
    },
    "Tampa - Spot": {
      "contract_validity": "Monthly",
      "contract_id": "WQ-161",
      "quotation_start_date": "2026-03-23T00:00:00.000Z"
    },
    "Richmond - Spot": {
      "contract_validity": "Monthly",
      "contract_id": "WQ-154",
      "quotation_start_date": "2026-03-23T00:00:00.000Z"
    },
    "Dallas - Firm": {
      "contract_validity": "Monthly",
      "contract_id": "WQ-072",
      "quotation_start_date": "2026-03-01T00:00:00.000Z"
    },
    "Seattle - Firm": {
      "contract_validity": "Monthly",
      "contract_id": "WQ-082",
      "quotation_start_date": "2026-03-01T00:00:00.000Z"
    }
  }
}